﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { IExcelChartField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.ExcelChartField, eOutputFieldType.excelChart)
export class ExcelChartField extends OutputField implements IExcelChartField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public deleted: boolean;
    public sheetName: string;
    public tableInsertCoord: string;
    public chartTitle: string;
}
